// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"6e99bd02","551":"6c8f8d8e"}[chunkId] + ".chunk.js";
};